<template>
  <b-row :show="showLoading" spinner-variant="primary">
    <b-col cols="12" class="container min-vh-100">
      <b-row>
        <b-card class="w-100 h-100">
          <ValidationObserver ref="form">
            <b-row>
              <b-col cols="12">
                <h3 class="mt-3 mb-1">แจ้งเบาะแส</h3>
              </b-col>

              <!-- ชื่อเรื่องแจ้งเบาะแส -->
              <b-col cols="12" class="">
                <b-form-group>
                  <label for="clueIssue">
                    ชื่อเรื่องแจ้งเบาะแส <span class="text-danger">*</span>
                  </label>
                  <ValidationProvider
                    rules="required"
                    name="ชื่อเรื่องแจ้งเบาะแส"
                    v-slot="{ errors }"
                  >
                    <b-form-input
                      id="clueIssue"
                      v-model="clueData.clueIssue"
                      placeholder="กรุณากรอก ชื่อเรื่องแจ้งเบาะแส"
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <!-- รายละเอียดเรื่องแจ้งเบาะแส -->
              <b-col cols="12" class="">
                <b-form-group>
                  <label for="clueDetail">
                    รายละเอียดเรื่องแจ้งเบาะแส<span class="text-danger">*</span>
                  </label>
                  <ValidationProvider
                    rules="required"
                    name="รายละเอียดเรื่องแจ้งเบาะแส"
                    v-slot="{ errors }"
                  >
                    <b-form-textarea v-model="clueData.clueDetail" rows="5" />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <!-- ชื่อสถานที่พบหรือชื่อผู้ประกอบการ -->
              <b-col cols="12" class="">
                <b-form-group>
                  <label for="companyName">
                    ชื่อสถานที่พบหรือชื่อผู้ประกอบการ
                    <span class="text-danger">*</span>
                  </label>
                  <!-- <ValidationProvider
                    rules="required"
                    name="ผู้ประกอบธุรกิจ"
                    v-slot="{ errors }"
                  >
                    <b-form-input
                      id="companyName"
                      v-model="clueData.companyName"
                      @input="onInputChange"
                      placeholder="กรุณากรอก ผู้ประกอบธุรกิจ"
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider> -->
                  <ValidationProvider
                    rules="required"
                    name="ชื่อสถานที่พบหรือชื่อผู้ประกอบการ"
                    v-slot="{ errors }"
                  >
                    <b-form-group>
                      <vue-autosuggest
                        v-model="clueData.companyName"
                        :value="clueData.companyName"
                        :suggestions="filteredOptionsCompany"
                        :limit="limit"
                        :input-props="inputPropsCompany"
                        @selected="onSelectedCompany"
                        @input="onInputChangeCompany"
                        :get-suggestion-value="getSuggestionValue"
                      >
                        <template slot-scope="{ suggestion }">
                          <span class="my-suggestion-item">{{
                            suggestion.item.label
                          }}</span>
                        </template>
                      </vue-autosuggest>
                      <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <!-- <b-col cols="12" class="mb-2">
                <LongdoMap @load="onLongdoLoad" :center="map.center" :apiKey="map.apiKey" >
                  <template slot-scope="{ map }">
                    <LongdoMapMarker
                      @load="onMarkerLoad"
                      :map="map"
                      :marker="marker"
                    ></LongdoMapMarker>
                  </template>
                </LongdoMap>
              </b-col> -->

              <!-- ที่อยู่ที่สามารถติดต่อได้ผู้ถูกแจ้งเบาะแส -->
              <b-card class="m-1 border border-primary w-100">
                <h4>ที่อยู่ที่สามารถติดต่อได้ผู้ถูกแจ้งเบาะแส</h4>

                <!-- longdo map -->
                <b-col cols="12" class="mt-1 mb-1">
                  <b-col
                    v-if="
                      clueData.companyLongitude !== null &&
                        clueData.companyLongitude !== '' &&
                        clueData.companyLongitude !== undefined &&
                        clueData.companyLatitude !== null &&
                        clueData.companyLatitude !== '' &&
                        clueData.companyLatitude !== undefined
                    "
                  >
                    <longdo-map
                      @load="eventMap"
                      :zoom="10"
                      :lastView="false"
                      :location="{
                        lon: clueData.companyLongitude,
                        lat: clueData.companyLatitude,
                      }"
                      style="height: 420px;"
                    >
                      <longdo-map-marker
                        :zoom="10"
                        :lastView="false"
                        :draggable="true"
                        v-for="(item, i) in markers"
                        :key="i"
                        :location="item.location"
                      />
                    </longdo-map>
                  </b-col>
                  <b-col v-else>
                    <longdo-map
                      @load="eventMap"
                      :zoom="10"
                      :lastView="false"
                      :location="{ lon: 100.512924, lat: 13.735675 }"
                      style="height: 420px;"
                    >
                      <longdo-map-marker
                        :location="{ lon: 100.512924, lat: 13.735675 }"
                        :draggable="true"
                      />
                    </longdo-map>
                  </b-col>
                </b-col>

                <!-- ที่อยู่ ตำบล อำเภอ จังหวัด รหัสไปรษณีย์ -->
                <b-row>
                  <!-- ที่อยู่ -->
                  <b-col cols="12" class="">
                    <b-form-group>
                      <label for="address">ที่อยู่</label>
                      <ValidationProvider name="ที่อยู่" v-slot="{ errors }">
                        <b-form-input
                          v-if="
                            clueData.addressModel.address1 !== undefined &&
                              clueData.addressModel.address1 !== null &&
                              clueData.addressModel.address1 !== ''
                          "
                          id="address"
                          :v-model="clueData.addressModel.address1"
                          :value="clueData.addressModel.address1"
                          :readonly="true"
                        />
                        <b-form-input
                          v-else
                          id="address"
                          :readonly="false"
                          placeholder="กรุณากรอก ที่อยู่"
                        />
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </b-col>
                  <!-- ตำบล -->
                  <b-col cols="12" md="6" class="">
                    <b-form-group>
                      <label for="tumbon">ตำบล</label>
                      <ValidationProvider name="ตำบล" v-slot="{ errors }">
                        <vue-autosuggest
                          :v-model="clueData.addressModel.tumbon"
                          :value="clueData.addressModel.tumbon"
                          :suggestions="filteredOptions"
                          :limit="limit"
                          :input-props="inputProps"
                          @selected="onSelected"
                          @input="onInputChange"
                          :get-suggestion-value="getSuggestionValue"
                        >
                          <template slot-scope="{ suggestion }">
                            <span class="my-suggestion-item">{{
                              suggestion.item.label
                            }}</span>
                          </template>
                        </vue-autosuggest>
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </b-col>
                  <!-- อำเภอ -->
                  <b-col cols="12" md="6" class="">
                    <b-form-group>
                      <label for="ampher">อำเภอ</label>
                      <ValidationProvider name="อำเภอ" v-slot="{ errors }">
                        <b-form-input
                          id="ampher"
                          v-model="clueData.addressModel.ampher"
                          :readonly="true"
                          placeholder="กรุณากรอก อำเภอ"
                        />
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </b-col>
                  <!-- จังหวัด -->
                  <b-col cols="12" md="6" class="">
                    <b-form-group>
                      <label for="province">จังหวัด</label>
                      <ValidationProvider name="จังหวัด" v-slot="{ errors }">
                        <b-form-input
                          id="province"
                          v-model="clueData.addressModel.province"
                          :readonly="true"
                          placeholder="กรุณากรอก จังหวัด"
                        />
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </b-col>
                  <!-- รหัสไปรษณีย์ -->
                  <b-col cols="12" md="6" class="">
                    <b-form-group>
                      <label for="Tel">รหัสไปรษณีย์</label>
                      <ValidationProvider
                        name="รหัสไปรษณีย์"
                        v-slot="{ errors }"
                      >
                        <b-form-input
                          id="zipCode"
                          v-model="clueData.addressModel.zipCode"
                          :readonly="true"
                          placeholder="กรุณากรอก รหัสไปรษณีย์"
                        />
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>

              <!-- ช่องทางที่พบเบาะแส -->
              <b-col cols="12">
                <ContactInput
                  :contacts="clueData.clueContacts"
                  :labelTitle="'ช่องทางที่พบเบาะแส'"
                  :isClue="true"
                  @handleChanged="onHandleContactChaned"
                />
              </b-col>

              <!-- เอกสารประกอบการแจ้งเบาะแส -->
              <b-col cols="12">
                <FileUploadWithSelectToOcpbCare
                  class="row"
                  :isClue="true"
                  :attachFiles="clueData.attachFiles"
                  :labelTitle="'เอกสารประกอบการแจ้งเบาะแส'"
                  @handleChanged="onHandleFileUploadChanged"
                />
              </b-col>

              <!-- ข้อมูลติดต่อกลับผู้แจ้งเบาะแส -->
              <b-card class="m-1 border border-primary w-100">
                <h4>ข้อมูลติดต่อกลับผู้แจ้งเบาะแส</h4>
                <b-row>
                  <b-col cols="12" md="6" class="">
                    <b-form-group>
                      <label for="name">ชื่อ</label>
                      <ValidationProvider name="ชื่อ" v-slot="{ errors }">
                        <b-form-input
                          id="name"
                          v-model="clueData.name"
                          placeholder="กรุณากรอก ชื่อ"
                        />
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6" class="">
                    <b-form-group>
                      <label for="lastname">นามสกุล</label>
                      <ValidationProvider name="นามสกุล" v-slot="{ errors }">
                        <b-form-input
                          id="lastname"
                          v-model="clueData.lastname"
                          placeholder="กรุณากรอก นามสกุล"
                        />
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6" class="">
                    <b-form-group>
                      <label for="email">อีเมล</label>
                      <ValidationProvider name="อีเมล" v-slot="{ errors }">
                        <b-form-input
                          id="email"
                          v-model="clueData.email"
                          placeholder="กรุณากรอก อีเมล"
                        />
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6" class="">
                    <b-form-group>
                      <label for="Tel">เบอร์โทร</label>
                      <ValidationProvider name="เบอร์โทร" v-slot="{ errors }">
                        <b-form-input
                          id="Tel"
                          v-model="clueData.tel"
                          placeholder="กรุณากรอก เบอร์โทร"
                        />
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>

              <!-- ปุ่ม บันทึกข้อมูล / ยกเลิก -->
              <b-col cols="12" class="d-flex justify-content-between">
                <b-button variant="secondary" @click="onCancelBtnClicked">
                  ยกเลิก
                </b-button>
                <b-button variant="primary" @click="onSubmitBtnClicked2">
                  บันทึกข้อมูล
                </b-button>
              </b-col>
            </b-row>
          </ValidationObserver>
        </b-card>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BFormInput,
  BFormGroup,
  BFormSelect,
  BFormCheckbox,
  BFormRadioGroup,
  BFormDatepicker,
  BFormTimepicker,
  BFormFile,
  BListGroup,
} from "bootstrap-vue";

import VueSelect from "vue-select";

import { LongdoMap, LongdoMapMarker } from "longdo-map-vue";
LongdoMap.init({ apiKey: "d18a5094e659a4f85a8d21c443a54bbf" });

// import FileUploadWithSelect from "@/views/Complaint/Utils/FileUpload/FileUploadWithSelect.vue";
import FileUploadWithSelectToOcpbCare from "@/views/Complaint/Utils/FileUpload/FileUploadWithSelectToOcpbCare.vue";
import ContactInput from "@/views/Complaint/Utils/Contact/ContactInput.vue";

import { VueAutosuggest } from "vue-autosuggest";

import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";

import * as clueStore from "@/store/api/clue/index.js";
import * as userStore from "@/store/api/user/index.js";
import * as companyStore from "@/store/api/company/index.js";
import * as storeMaster from "@/store/api/master/index.js";
import * as consultStore from "@/store/api/consult/index.js";
import * as complaintStore from "@/store/api/complaint/complaint.js";
import * as storeFileUpload from "@/store/api/fileUpload/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import * as lang from "vuejs-datepicker/src/locale";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "กรุณากรอก{_field_}",
  computesRequired: true,
});
export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BFormCheckbox,
    BFormRadioGroup,
    BFormDatepicker,
    BFormTimepicker,
    BFormFile,
    BListGroup,
    ValidationObserver,
    ValidationProvider,
    extend,
    VueSelect,
    VueAutosuggest,
    // FileUploadWithSelect,
    ContactInput,
    VueAutosuggest,
    LongdoMap,
    LongdoMapMarker,
    FileUploadWithSelectToOcpbCare,
  },
  props: {
    mode: "Default",
    gcc: null,
  },
  data() {
    return {
      showLoading: false,
      clueData: {
        clueIssue: "",
        clueDetail: "",
        clueContacts: [{ contactTypeId: 2, description: "" }],

        companyLongitude: "",
        companyLatitude: "",
        companyName: "",

        gccId: null,

        attachFiles: [],
        addressModel: {
          address1: "",
          address2: "",
          tumbon: "",
          ampher: "",
          province: "",
          zipCode: "",
        },
      },
      attachFiles: [],
      address: {},
      consultDetail: [],
      masterIdList: [],
      personal: null,
      attachTypes: [{ value: null, text: "ประเภทเอกสาร", disabled: true }],
      selected: 13,
      activeOptions: [
        { text: "ใช้งาน", value: true },
        { text: "ไม่ใช้งาน", value: false },
      ],
      modalMode: "",
      currentUserIdModal: "",
      datasuggest: [],
      filteredOptions: [],
      inputProps: {
        id: "tumbonAutoSuggest",
        class: "form-control",
        placeholder: "ตำบล",
      },
      limit: 10,
      languages: lang.th,
      map: {
        apiKey: "4f2fe3c11bf4bd638def575832093f1a", // API Key
        center: {
          lon: 100,
          lat: 16,
        },
      },

      filteredOptionsCompany: [],
      inputPropsCompany: {
        id: "companyAutoSuggest",
        class: "form-control",
        placeholder: "ชื่อสถานที่พบหรือชื่อผู้ประกอบการ",
      },
      defaultAddress: "ไม่ระบุ",
      markers: [
        {
          location: { lon: 100.5, lat: 13.75 },
        },
      ],
    };
  },
  created() {
    extend("checkRequired", {
      validate(value) {
        return {
          required: true,
          valid: _this.tab3check(),
        };
      },
      message: "กรุณาเลือก{_field_} อย่างน้อย 1 หมวดหมู่",
      computesRequired: true,
    });
  },
  methods: {
    eventMap(map) {
      const _this = this;
      map.Ui.Crosshair.visible(false);
      // map.Ui.lockMap(false);
      // console.log("eventMap", map);

      map.Event.bind("overlayDrop", function(overlay) {
        // console.log(
        //   "on overlayDrop",
        //   overlay,
        //   overlay.location(),
        //   overlay.collection.geometry()
        // );

        storeMaster
          .getAddressByGetByLongDooMap(
            overlay.location().lat,
            overlay.location().lon
          )
          .then((response) => {
            // console.log("getAddressByGetByLongDooMap", response);

            _this.clueData.addressModel.tumbonCode =
              response.data.data.subDistrictCode;
            _this.clueData.addressModel.tumbon =
              response.data.data.subDistrictName;
            _this.clueData.addressModel.ampherCode =
              response.data.data.districtCode;
            _this.clueData.addressModel.ampher =
              response.data.data.districtName;
            _this.clueData.addressModel.provinceCode =
              response.data.data.provinceCode;
            _this.clueData.addressModel.province =
              response.data.data.provinceName;
            _this.clueData.addressModel.zipCode = response.data.data.zipcode;

            _this.$forceUpdate();
          });

        map.location(
          { lon: overlay.location().lon, lat: overlay.location().lat },
          true
        ); // set center
      });

      // หลังจาก marker ขยับตาม query ชื่อผู้ประกอบการ
      map.Event.bind("overlayChange", function(overlay) {
        // console.log("overlayChange");
        map.location(
          { lon: overlay.location().lon, lat: overlay.location().lat },
          true
        ); // set center
      });
    },
    onHandleFileUploadChanged(attachs) {
      // console.log("attachs", attachs);
      this.clueData.attachFiles = attachs;
    },
    onHandleContactChaned(cts) {
      // console.log("cts", cts);
      this.clueData.clueContacts = cts;
    },
    getCompanyName(text) {
      const _this = this;
      storeMaster
        .getCompanyAutocompleteName(text)
        .then(function(response) {
          // console.log("getCompanyAutocompleteName", response.data.data);
        })
        .catch(function(error) {
          // console.log("error", error);
        });
    },
    getFileType() {
      const _this = this;
      storeMaster
        .getMasterByType()
        .then(function(response) {
          // handle success
          //console.log('then', response);

          var convertData = response.data.data.map(function(item, index) {
            return {
              value: item.masterId,
              text: item.description,
            };
          });

          _this.attachTypes = convertData;
        })
        .catch(function(error) {
          // handle error
          // console.log("error", error);
        })
        .then(function() {
          // always executed
        });
    },
    onInputChange(text) {
      const _this = this;
      if (text === "" || text === undefined) {
        return;
      }
      if (text.length < 3) {
        return;
      }

      storeMaster
        .getSubDistrictAutoComplete(text)
        .then((response) => {
          // console.log("response", response);
          /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
          const filteredAry = response.data.data.slice(0, this.limit);
          _this.filteredOptions = [
            {
              data: filteredAry,
            },
          ];

          // console.log("_this", _this.filteredOptions);
        })
        .catch((error) => {
          // console.log("error", error);
        });
    },
    onInputChangeCompany(text) {
      const _this = this;

      if (text === "" || text === undefined) {
        return;
      }

      if (text.length < 3) {
        return;
      }

      companyStore
        .getByName(text)
        .then((response) => {
          // console.log("onInputChangeCompany 1", response);
          /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
          const filteredCompany = response.data.data.slice(0, this.limit);
          _this.filteredOptionsCompany = [
            {
              data: filteredCompany,
            },
          ];

          // console.log("onInputChangeCompany 2", filteredCompany);
          // console.log("onInputChangeCompany 3", _this.filteredOptionsCompany);
          // console.log("onInputChangeCompany 4", _this.clueData.companyName);
        })
        .catch((error) => {
          // console.log("error", error);
        });
    },
    getSuggestionValue(suggestion) {
      // console.log("getSuggestionValue", suggestion);
      return suggestion.item.label;
    },
    onSelected(option) {
      // เลือกตำบล
      const _this = this;
      storeMaster
        .getAddressBySubDistrictCode(option.item.value)
        .then((response) => {
          _this.clueData.addressModel.tumbonCode =
            response.data.data.subDistrictCode;
          _this.clueData.addressModel.tumbon =
            response.data.data.subDistrictName;
          _this.clueData.addressModel.ampherCode =
            response.data.data.districtCode;
          _this.clueData.addressModel.ampher = response.data.data.districtName;
          _this.clueData.addressModel.provinceCode =
            response.data.data.provinceCode;
          _this.clueData.addressModel.province =
            response.data.data.provinceName;
          _this.clueData.addressModel.zipCode = response.data.data.zipcode;

          _this.$forceUpdate();
        });
    },
    onSelectedCompany(option) {
      // เลือกผู้ประกอบธุรกิจ
      const _this = this;

      // รายละเอียดที่อยู่ของผู้ประกอบธุรกิจ
      companyStore
        .getAddressDetail(option.item.value) // option.item.value :=> Id ผู้ประกอบธุรกิจ
        .then((response) => {
          // clue - main
          _this.clueData.companyName = option.item.label;
          this.clueData.address1 = response.data.data.address1;
          this.clueData.address2 = response.data.data.address2;
          _this.clueData.companyLatitude = response.data.data.latitude.toString();
          _this.clueData.companyLongitude = response.data.data.longitude.toString();
          // clue - addressModel
          _this.clueData.addressModel.address1 = response.data.data.address1;
          _this.clueData.addressModel.address2 = response.data.data.address2;
          _this.clueData.addressModel.tumbonCode =
            response.data.data.tumbonCode;
          _this.clueData.addressModel.tumbon = response.data.data.tumbon;
          _this.clueData.addressModel.ampherCode =
            response.data.data.ampherCode;
          _this.clueData.addressModel.ampher = response.data.data.ampher;
          _this.clueData.addressModel.provinceCode =
            response.data.data.provinceCode;
          _this.clueData.addressModel.province = response.data.data.province;
          _this.clueData.addressModel.zipCode = response.data.data.zipcode;

          _this.markers = [];
          if (
            response.data.data.latitude !== null &&
            response.data.data.longitude !== null
          ) {
            _this.markers[0] = {
              location: {
                lon: response.data.data.longitude,
                lat: response.data.data.latitude,
              },
            };
            // console.log("markers", _this.markers);
          } else {
            _this.markers[0] = { location: { lon: 100.5, lat: 13.75 } };
          }
        })
        .catch((error) => {
          // console.log("error", error);
        });
    },
    onLoading(loading) {
      this.showLoading = loading;
    },
    onSubmitBtnClicked() {
      const _this = this;

      this.$refs.form.validate().then((success) => {
        if (success) {
          // console.log("onSubmitBtnClicked - success", _this.clueData);
          // confirm address company
          if (
            _this.clueData.addressModel.address1 === null ||
            _this.clueData.addressModel.address1 === "" ||
            _this.clueData.addressModel.address1 === undefined
          ) {
            // console.log("confirm address company");
            var addr = document.getElementById("address").value;
            // console.log("confirm address company", addr);
            if (addr !== null && addr !== "" && addr !== undefined) {
              _this.clueData.addressModel.address1 = addr;
            }
          }
        } else {
          return;
        }
        this.$swal({
          title: "ยืนยันการบันทึกข้อมูล?",
          text: "",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "บันทึก",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-primary ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            _this.clueData.gccId = _this.gcc;
            clueStore
              .updateItem(_this.clueData)
              .then((response) => {
                if (response.data.success === true) {
                  _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกข้อมูลของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });

                  if (_this.mode === "GCC") {
                    window.open(
                      _this.$router.resolve({
                        name: "GCC",
                      }).href,
                      "_self"
                    );
                  } else {
                    window.open(
                      _this.$router.resolve({
                        name: "ClueSearch",
                      }).href,
                      "_self"
                    );
                  }
                } else {
                  _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                    title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                    variant: "danger",
                    solid: false,
                  });
                }
              })
              .catch((error) => {
                // console.log("error", error);
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              });
          }
        });
      });
    },
    onSubmitBtnClicked2() {
      console.log(1);
      this.$refs.form.validate().then((success) => {
        console.log(2);
        if (!success) return;

        console.log(3);
        if (
          this.clueData.addressModel.address1 === null ||
          this.clueData.addressModel.address1 === "" ||
          this.clueData.addressModel.address1 === undefined
        ) {
          var addr = document.getElementById("address").value;
          if (addr !== null && addr !== "" && addr !== undefined) {
            this.clueData.addressModel.address1 = addr;
          }
        }

        console.log(4);
        this.$swal({
          title: "ยืนยันการบันทึกข้อมูล?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "บันทึก",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-primary ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (!result.isConfirmed) return;

          console.log(5);

          // 🔵 Swal ที่ 2 : Loading (lock screen)
          this.$swal({
            title: "กำลังส่งเรื่องไปยังระบบเฝ้าระวังฯ (OCPB Care)",
            text:
              "กรุณารอสักครู่และโปรดอย่าปิดหรือรีโหลดหน้า website นี้ ขณะกำลังส่งเรื่อง . . .",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
              this.$swal.showLoading();
            },
          });

          console.log(6);

          this.clueData.gccId = this.gcc;

          // 🔵 Call API
          clueStore
            .updateItem(this.clueData)
            .then((response) => {
              console.log("7");

              // ปิด loading
              this.$swal.close();

              console.log(8);
              if (response.data.success === true) {
                console.log(8.1);

                var title = `ส่งเรื่องไปยังระบบเฝ้าระวังฯ (OCPB Care) สำเร็จ`;
                try {
                  console.log("8.2");
                  title = `ส่งเรื่องไปยังระบบเฝ้าระวังฯ (OCPB Care) สำเร็จ (${response.data.data.result.clueCode})`;
                } catch (e) {
                  console.log("8.3", e);
                }

                console.log("8.4");

                // this.$swal({
                //   icon: "success",
                //   title: title,
                //   text: "ระบบได้บันทึกข้อมูลของท่านแล้ว", 
                //   showConfirmButton: false,
                //   timer: 1000,
                // }).then((result) => {
                //   const routeName = this.mode === "GCC" ? "GCC" : "ClueSearch";
                //   window.open(
                //     this.$router.resolve({ name: routeName }).href,
                //     "_self"
                //   );
                // });

                // Swal Success
                this.$swal({
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                  icon: "success",
                  title: title,
                  text: "ระบบได้บันทึกข้อมูลของท่านแล้ว",
                  confirmButtonText: "ตกลง",
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                }).then(() => {
                  // Redirect หลัง user กดปุ่ม
                  console.log(9);
                  const routeName = this.mode === "GCC" ? "GCC" : "ClueSearch";
                  window.open(
                    this.$router.resolve({ name: routeName }).href,
                    "_self"
                  );
                });
              } else {
                console.log(10);
                this.$swal({
                  icon: "error",
                  title:
                    "ส่งเรื่องไปยังระบบเฝ้าระวังฯ (OCPB Care) ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
                  text: "เกิดข้อผิดพลาดในการบันทึกข้อมูล",
                  confirmButtonText: "ปิด",
                });
              }
            })
            .catch((err) => {
              console.log("999", err);

              // ปิด loading
              this.$swal.close();

              this.$swal({
                icon: "error",
                title:
                  "ส่งเรื่องไปยังระบบเฝ้าระวังฯ (OCPB Care) ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
                text: "เกิดข้อผิดพลาดในการบันทึกข้อมูล",
                confirmButtonText: "ปิด",
              });
            });
        });
      });
    },
    // onSubmitBtnClicked3() {
    //   let progressInterval;
    //   let currentPercent = 0;

    //   this.$swal({
    //     title: "กำลังนำส่งเรื่องไปยังระบบ OCPB Care",
    //     html: `
    // <div>
    //   กำลังประมวลผล <span id="swal-percent">0</span>%
    //   <div style="margin-top:8px">
    //     <progress id="swal-progress" value="0" max="100" style="width:100%"></progress>
    //   </div>
    // </div>
    //     `,
    //     timer: 1000000, // 10 วินาที
    //     timerProgressBar: true,
    //     allowOutsideClick: false,
    //     allowEscapeKey: false,
    //     showConfirmButton: false,
    //     didOpen: () => {
    //       this.$swal.showLoading();

    //       const percentEl = document.getElementById("swal-percent");
    //       const barEl = document.getElementById("swal-progress");

    //       progressInterval = setInterval(() => {
    //         // 🚫 ไม่เกิน 90%
    //         if (currentPercent < 90) {
    //           currentPercent += 10;
    //           percentEl.textContent = currentPercent;
    //           barEl.value = currentPercent;
    //         }
    //       }, 1000); // ปรับความเร็วได้
    //     },
    //     willClose: () => {
    //       clearInterval(timerInterval);
    //     },
    //   });
    // },
    onCancelBtnClicked() {
      if (this.mode === "GCC") {
        window.open(this.$router.resolve({ name: "GCC" }).href, "_self");
      } else {
        window.open(this.$router.resolve({ name: "ClueSearch" }).href, "_self");
      }
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
</style>